import { render, staticRenderFns } from "./Familias.vue?vue&type=template&id=734faf13&scoped=true"
import script from "./Familias.vue?vue&type=script&lang=js"
export * from "./Familias.vue?vue&type=script&lang=js"
import style0 from "./Familias.vue?vue&type=style&index=0&id=734faf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734faf13",
  null
  
)

export default component.exports